import { Component, EventEmitter, HostListener, input, Input, InputSignal, Output } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'ph-button',
    templateUrl: 'ph-button.component.html',
    styleUrls: ['ph-button.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent],
    standalone: true
})
export class PhButtonComponent {

    loading: InputSignal<boolean> = input<boolean>(false);
    @Input() type: 'primary' | 'secondary' | 'danger' = 'secondary';
	@Input() id: string;
	@Input() icon: string;
	@Input() disabled: boolean = false;
    @Input() active: boolean = false;
	@Input() height: number = 40;
	@Input() link: Array<string | number> = [];
	@Input() linkParams: Object = {};
    @Input() tabIndex: number = 0;

	@Output('buttonClick') clickEmitter: EventEmitter<Event> = new EventEmitter<Event>();

	constructor() {}

	@HostListener('focusin') onFocus(): void {
		if (this.tabIndex === -1) (document.activeElement as HTMLElement)?.blur();
	}
}
